const NOOP = 'noop'
const INITIALIZING = 'initializing'
const INITIALIZED = 'initialized'
const INITIALIZATION_FAILED = 'initialization-failed'
const SECURE_CONSTANTS_FETCHED = 'fetched'

export default {
  NOOP,
  INITIALIZATION_FAILED,
  INITIALIZED,
  INITIALIZING,
  SECURE_CONSTANTS_FETCHED,
}
